export const EVENTS = {
  // ログイン・ログアウト
  log_in: 'en_log_in',
  log_out: 'en_log_out',
  // 登録
  user_registration_start: 'en_user_registration_start',
  user_account_create: 'en_user_account_create',
  user_account_registration_display: 'en_user_account_registration_display',
  user_career_register: 'en_user_career_register',
  user_value_answer: 'en_user_value_answer',
  user_information_fill: 'en_user_information_fill',
  // 登録_ユーザー情報
  registration_name_display: 'en_registration_name_display',
  registration_birthday_display: 'en_registration_birthday_display',
  registration_prefecture_display: 'en_registration_prefecture_display',
  registration_workplace_display: 'en_registration_workplace_display',
  registration_job_experience_display: 'en_registration_job_experience_display',
  registration_experience_levels_display:
    'en_registration_experience_levels_display',
  registration_annual_income_display: 'en_registration_annual_income_display',
  registration_job_change_intention_display:
    'en_registration_job_change_intention_display',
  registration_desired_employment_type_display:
    'en_registration_desired_employment_type_display',
  registration_phone_number_display: 'en_registration_phone_number_display',
  // 価値観診断
  value_top_display: 'en_value_top_display',
  value_report_display: 'en_value_report_display',
  // TOP
  top_display: 'en_top_display',
  // 新着求人
  new_job_offer_display: 'en_new_job_offer_display',
  // シナリオ
  scenario_top_display: 'en_scenario_top_display',
  scenario_job_offer_display: 'en_scenario_job_offer_display',
  scenario_detail_display: 'en_scenario_detail_display',
  // エージェントリスト
  agent_list_display: 'en_agent_list_display',
  // 面談
  interview_message_open: 'en_interview_message_open',
  interview_apply: 'en_interview_apply',
  // スカウト
  scout_message_open: 'en_scout_message_open',
  scout_message_entry: 'en_scout_message_entry',
  // 退会
  withdraw: 'en_withdraw'
} as const;

export type Events = (typeof EVENTS)[keyof typeof EVENTS];
